import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useHistory } from 'react-router-dom';
import '../App.css';
import AplicacionContext from '../context/AplicacionContext';
import Pie from './Pie';

function Menu () {

    const history = useHistory();
    const context = useContext(AplicacionContext);

    function fiscalizacion () {
      context.changeApp("Consulta Licencia");
      history.push("/fiscalizacion");
    }

    function vtv () {
      context.changeApp("Consulta VTV");
      history.push("/vtv");
    }

    function dominial () {
      context.changeApp("Consulta Patente");
      history.push("/dominial");
    }

    function infracciones () {
      window.open('https://infraccionesba.gba.gob.ar/consulta-infraccion', '_blank');
    }



    return(
    <>  
    <div className="container">   
      <div className="row" style={{fontFamily:'Encode Sans', justifyContent:'center'}}>   
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
        <Card style={{marginTop:30, transition:'transform .2s', minHeight:220}} className="zoom-page">
        <Card.Header className="text-center" style={{fontSize:26, backgroundColor: '#00b1c7', color: 'white'}}>Consulta Licencia</Card.Header>
          <Card.Body className="text-center">
            <Card.Text>
              Acceda a la Consulta de Licencias
            </Card.Text>
            <Button style={{backgroundColor:'#00b1c7', borderColor:'#00b1c7'}} onClick={fiscalizacion}>Acceder</Button>
          </Card.Body>
        </Card>
        </div>
        {<div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
        <Card style={{marginTop:30, transition:'transform .2s', minHeight:220}} className="zoom-page">
        <Card.Header className="text-center" style={{fontSize:26, backgroundColor: '#00b1c7', color: 'white'}}>Consulta Patente</Card.Header>
          <Card.Body className="text-center">            
            <Card.Text>
            Acceda a la Consulta de Control de Patente del Vehículo
            </Card.Text>
            <Button style={{backgroundColor:'#00b1c7', borderColor:'#00b1c7'}} onClick={dominial}>Acceder</Button>
          </Card.Body>
        </Card>
        </div>}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
        <Card style={{marginTop:30, transition:'transform .2s', minHeight:220}} className="zoom-page">
        <Card.Header className="text-center" style={{fontSize:26, backgroundColor: '#00b1c7', color: 'white'}}>Consulta VTV</Card.Header>
          <Card.Body className="text-center">
            <Card.Text>
              Acceda a la Consulta de VTV
            </Card.Text>
            <Button style={{backgroundColor:'#00b1c7', borderColor:'#00b1c7'}} onClick={vtv}>Acceder</Button>
          </Card.Body>
        </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
        <Card style={{marginTop:30, transition:'transform .2s', minHeight:220}} className="zoom-page">
        <Card.Header className="text-center" style={{fontSize:26, backgroundColor: '#00b1c7', color: 'white'}}>Consulta Infracciones</Card.Header>
          <Card.Body className="text-center">
            <Card.Text>
              Acceda a la Consulta de Infracciones de tránsito
            </Card.Text>
            <Button style={{backgroundColor:'#00b1c7', borderColor:'#00b1c7'}} onClick={infracciones}>Acceder</Button>
          </Card.Body>
        </Card>
        </div>
      </div> 
    </div>
    <Pie></Pie>
    </>
     
    );
}

export default Menu;
